import React, {useEffect, useState} from 'react'
import HeaderCard from "../../common/header-author/Header-Card";
import CardCommon from "../../cards/CardCommon";
import {get} from "sodon-http/API";
import {API_URL} from "../../../constans/API_URL";
import CustomPopup from "../../common/pop-up/CustomPopup";
import MovieModal from "../../modal/MovieModal";
import {useQuery} from "@tanstack/react-query";

export default function Finished() {

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const { data: completed } = useQuery({
        queryKey: ['completed',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/list?movieStatus=COMPLETED`);
        },
    });


    const data = completed?.payload?.thisPageElements.slice(0,16);


    function openDialog(item) {
        setSelectedItem(item);
        setIsDialogOpen(true);
    }

    function handleClose(e) {
        setIsDialogOpen(false);
    }


    return (
        <div className={"container"}>
            <HeaderCard title={"Дуусгасан төслүүд"} link={"/all-projects-completed"}/>
            <div className={"mt-5 grid xl:grid-cols-8 lg:grid-cols-8 gap-4 md:grid-cols-4 sm:grid-cols-3 max-sm:grid-cols-3"}>
                {
                    data && data.map((item, index) => (
                        <CardCommon key={index} item={item} onClick={() => {openDialog(item)}}/>
                    ))
                }
            </div>
            <CustomPopup open={isDialogOpen} close={handleClose}>
                <MovieModal
                    item={selectedItem}
                    shown={isDialogOpen}
                    setShown={value => setIsDialogOpen(value)}
                />
            </CustomPopup>
        </div>
    )
}
